module.exports = __webpack_public_path__ + "img/espacamento_madres.5cae69c1.png";